import { Injectable } from '@angular/core';

import { AuthService } from "../../../shared/services/auth.service";
import { editRoute, newRoute } from "../../../shared/services/data.service";
import { abastecimentosRoute} from "../../shared/data.service";
import { abastecimentoBensRoute} from "./data.service";

@Injectable()
export class AbastecimentoBemNavigationService {

    constructor(
        private _authService: AuthService
    ) { }

    goToList() {
        let router: string = abastecimentosRoute + '/' + abastecimentoBensRoute;
        this._authService.navigateTo(router);
    }

    goToNew() {
        let router: string = abastecimentosRoute + '/' + abastecimentoBensRoute + '/' + newRoute;
        this._authService.navigateTo(router);
    }

    goToEdit(objectId: number) {
        let router: string = abastecimentosRoute + '/' + abastecimentoBensRoute + '/' + editRoute;
        this._authService.navigateTo(router, objectId);
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/abastecimento-bens/shared/abastecimento-bem-navigation.service.ts
 **/